import React from "react";

export default function About() {
  return (
    <div className="pt-8 pb-8 bg-gray-400">
      <div className="container mx-auto" id="about">
        <div className="flex flex-col">
          <h4 className="text-2xl text-white font-semibold">About Me</h4>
          <div className="p-8">
            <p className="text-white text-xl">
              Hi there! I am Vivekanand. First of all, welcome to my website,
              and thank you for visiting it and trying to learn more about me.
            </p>
            <p className="text-white text-xl">
              I made this website to showcase the projects I worked on.
            </p>
            <p className="text-white text-xl">
              Feel free to check out my work and contact me if you need any help
              in web development.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
